class VendorLoader extends HTMLElement {
  constructor() {
    super();
    this.sectionId = "vendors";
    this.registryKey = "vendors_registry";
    this.expiryKey = "vendors_registry_expiry"; // store expiry timestamp
    this.vendors = {};
    this.TTL = 4 * 60 * 60 * 1000; // 4 hours in milliseconds
  }

  connectedCallback() {
    this.heading = this.getAttribute("heading") || "Vendors";
    this.collections = (this.getAttribute("collections") || "")
      .split(",")
      .map(c => c.trim())
      .filter(Boolean);

    this.innerHTML = `
      <div class="vendor-card">
        <h3 class="vendor-title">${this.heading}</h3>
        <ul class="vendor-list"></ul>
      </div>
    `;

    this.listEl = this.querySelector(".vendor-list");

    this.loadRegistry();
    this.fetchMissingVendors();
    this.render();
  }

  /* --------------------
     REGISTRY
  --------------------- */
  
  loadRegistry() {
    const expiry = localStorage.getItem(this.expiryKey);
    const now = Date.now();

    if (!expiry || now > parseInt(expiry, 10)) {
      // expired or missing
      this.vendors = {};
      localStorage.removeItem(this.registryKey);
      localStorage.removeItem(this.expiryKey);
    } else {
      this.vendors = JSON.parse(localStorage.getItem(this.registryKey) || "{}");
    }
  }

  
  saveRegistry() {
    localStorage.setItem(this.registryKey, JSON.stringify(this.vendors));
    localStorage.setItem(this.expiryKey, Date.now() + this.TTL); // set new expiry
  }

  /* --------------------
     FETCH (ONLY ADDS NEW DATA)
  --------------------- */
  async fetchMissingVendors() {
    for (const collection of this.collections) {
      let nextUrl = `/collections/${collection}?section_id=${this.sectionId}`;

      while (nextUrl) {
        const html = await fetch(nextUrl).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, "text/html");

        const nodes =
          doc.querySelectorAll(".vendor li").length
            ? doc.querySelectorAll(".vendor li")
            : doc.querySelectorAll(".product_vendor li");

        nodes.forEach(el => {
          const name = el.textContent.trim();
          if (!name) return;

          const handle = el.dataset.handle || this.slugify(name);

          // Create vendor ONCE
          if (!this.vendors[handle]) {
            this.vendors[handle] = {
              name,
              collections: []
            };
          }

          // Add collection reference (small array)
          if (!this.vendors[handle].collections.includes(collection)) {
            this.vendors[handle].collections.push(collection);
          }
        });

        nextUrl = doc.querySelector(".paginate")?.textContent?.trim() || null;
      }
    }

    this.saveRegistry();
    this.render();
  }

  /* --------------------
     RENDER (FILTERED)
  --------------------- */
  render() {
    this.listEl.innerHTML = "";

    Object.entries(this.vendors)
      .filter(([_, v]) =>
        this.collections.some(c => v.collections.includes(c))
      )
      .map(([handle, v]) => ({ handle, name: v.name }))
      .sort((a, b) => a.name.localeCompare(b.name))
      .forEach(v => {
        this.listEl.insertAdjacentHTML(
          "beforeend",
          `<li>
            <a href="/collections/${encodeURIComponent(v.handle)}">
              ${v.name}
            </a>
          </li>`
        );
      });
  }

  slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, "-")
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");
  }
}

customElements.define("vendor-loader", VendorLoader);

function switchTab(btn,id){
  document.querySelectorAll('.tab').forEach(function(e){
      e.classList.remove('show');
  });
  document.querySelectorAll('.toggle-tab').forEach(function(e){
      e.classList.remove('active')
  })
  document.querySelector(id).classList.add('show');
  btn.classList.add('active');
}